<template>
  <div class="biNav">
    <p class="page_title">三门峡市应急救援装备管理服务平台</p>
  </div>
</template>

<script>
export default {
  name: 'BiNav'
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/variables';
.biNav {
  width: 100%;
  height: auto;
  background-image: url('../../assets/img/nav_bg.png');
  //background-size: cover;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;

  .page_title {
    font-family: 'YouSheBiaoTiHei';
    font-size: 35px;
    text-align: center;
    margin: auto;
    color: $title-color;
    padding: 20px;
  }
}
</style>
